import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  fileUploaderWrapper: {
    display: 'flex',
    position: 'relative',
    '& .MuiInputLabel-root': {
      left: '28px',
      top: '1px',
      '&.MuiInputLabel-shrink': {
        left: '0',
        top: '0'
      }
    },
    '& .MuiOutlinedInput-root': {
      maxHeight: '48px'
    }
  },
  fileName: {
    position: 'absolute',
    top: '13px',
    left: '40px',
    fontFamily: palette.fontFamilies.source,
    fontSize: '18px',
    lineHeight: '24px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '80%',
    pointerEvents: 'none',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  startIcon: {
    position: 'absolute',
    zIndex: '10',
    top: '12px',
    left: '12px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& path': {
      fill: palette.shades[500]
    }
  },
  startPreviewIcon: {
    position: 'absolute',
    zIndex: '10',
    top: '6px',
    left: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& path': {
      fill: palette.shades[500]
    }
  },
  fileInput: {
    width: '100%'
  },
  fileInputWithDelete: {
    [breakpointsFunc.breakpoints.down('lg')]: {
      width: '95%'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '91%'
    }
  },
  deleteButton: {
    width: '48px',
    height: '48px',
    flexShrink: '0',
    marginLeft: '4px',
    borderColor: '#B8C4D1',
    [breakpointsFunc.breakpoints.down('lg')]: {
      marginLeft: '1px',
      width: 'calc(5% - 1px)'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      marginLeft: '1px',
      width: 'calc(9% - 1px)'
    }
  }
});
export default useStyles;